import React from "react";
import { Box, ListItemButton, Typography, alpha, useTheme, CircularProgress } from "@mui/material";
import { getInitials } from "../../utils/utils";
import { presenceDotColor } from "../../utils/teamPresence";

const PortalTeamUserRow = ({ user, selected, disabled, loading, onSelect }) => {
  const theme = useTheme();
  const label = user?.userName || "—";
  const presence = user?.presence === "online" ? "online" : "away";

  return (
    <ListItemButton
      dense
      selected={selected}
      disabled={disabled || loading}
      onClick={onSelect}
      sx={{
        mx: 1,
        mb: 0.25,
        borderRadius: 1.5,
        py: 0.75,
        color: "text.primary",
        "&.Mui-selected": {
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.14) },
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, width: "100%", minWidth: 0 }}>
        <Box sx={{ position: "relative", flexShrink: 0 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 600,
              bgcolor: selected ? "primary.main" : alpha(theme.palette.primary.main, 0.12),
              color: selected ? "primary.contrastText" : "primary.main",
              backgroundImage: user?.userAvatarUrl ? `url(${user.userAvatarUrl})` : undefined,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {!user?.userAvatarUrl ? getInitials(label) : null}
          </Box>
          <Box
            sx={{
              position: "absolute",
              right: -1,
              bottom: -1,
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: presenceDotColor(theme, presence),
              border: `2px solid ${theme.palette.background.paper}`,
            }}
          />
        </Box>
        <Typography variant="body2" color="text.primary" fontWeight={selected ? 600 : 500} noWrap sx={{ flex: 1 }}>
          {label}
        </Typography>
        {loading ? <CircularProgress size={16} /> : null}
      </Box>
    </ListItemButton>
  );
};

export default PortalTeamUserRow;
